const getURLS = () =>{
    return {
        otpAppURL: process.env.REACT_APP_API_KEY,
        tempBaseURL: process.env.REACT_APP_BASE_URL,
        sapApiURL: process.env.REACT_APP_BASE_SAP_URL_DEV,
        otpApiURL: process.env.REACT_APP_OTP_SERVICE,
    }
}

export default getURLS;